






























































import { Component, Mixins } from 'vue-property-decorator'
import { IMPORT_TYPES } from '@/classes/library'
import { LibraryMixin } from '@/mixins'
import { PAYMENT_PROVIDERS } from '../store/modules/auth'

@Component({})
export default class Sidebar extends Mixins(LibraryMixin) {
  get hasActiveSubscription() {
    return this.$store.state.subscription.active || this.$store.state.auth.isDemoUser
  }

  get allowGenerateSetlist(): boolean {
    return this.library.importType === IMPORT_TYPES.Traktor || this.library.importType === IMPORT_TYPES.VirtualDJ || this.library.importType === IMPORT_TYPES.EnginePrime
  }

  get showFreeMonthsOption(): boolean {
    return this.hasActiveSubscription &&
      this.$store.state.auth.userProps &&
      (
        this.$store.state.auth.userProps.paymentProvider === PAYMENT_PROVIDERS.Mollie ||
        this.$store.state.auth.userProps.paymentProvider === null
      )
  }

  get isDemoUser(): boolean {
    return this.$store.state.auth.isDemoUser
  }

  get isBetaUser(): boolean {
    return this.$store.getters['auth/isBetaUser']
  }
}
